<template>
  <section
    class="component-d6f08142"
    resmed-component-name="card_carousel_2col_icon-line_graphic_text_2cta"
    v-bind:style="style"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="headings text-center">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="'center'"
              ></eyebrow-icon>
              <h2 v-if="acf.headline" v-html="acf.headline"></h2>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper container px-xs-sm-2">
        <div class="row">
          <div class="col" style="padding: 0">
            <div class="seek">
              <div class="seek-wrapper" v-show="sliderControlsVisible">
                <a
                  ref="swiperButtonPrev"
                  href="#"
                  class="btn navigation-icon left-caret swiper-button-prev"
                ></a>
                <a
                  ref="swiperButtonNext"
                  href="#"
                  class="btn navigation-icon right-caret swiper-button-next"
                ></a>
              </div>

              <div
                ref="swiperContainer"
                class="swiper-container"
                v-bind:class="`-mode-${[$root.mode]}`"
              >
                <div class="items swiper-wrapper text-center">
                  <div
                    class="item swiper-slide mb-3 mb-md-0"
                    v-for="(item, index) in acf.items"
                    v-bind:class="{ overflow: overflow && index > 1 }"
                  >
                    <div
                      class="embed-responsive"
                      v-bind:class="{
                        'embed-responsive-1by1': $root.mode !== 'xs',
                        'embed-responsive-3by4': $root.mode === 'xs',
                      }"
                    >
                      <div
                        class="wrapper embed-responsive-item"
                        v-bind:style="{
                          'background-image': `url(${item.image.sizes.large})`,
                          'background-position': 'center center',
                          'background-size': 'cover',
                        }"
                      >
                        <figure>
                          <div
                            class="gradient embed-responsive"
                            v-bind:class="{
                              'embed-responsive-1by1': $root.mode !== 'xs',
                              'embed-responsive-3by4': $root.mode === 'xs',
                            }"
                          ></div>
                          <figcaption
                            v-bind:class="{
                              'text-color-reverse':
                                item['reverse-color'] === 'black',
                            }"
                          >
                            <h3 v-html="item.title"></h3>
                            <p v-html="item.description"></p>

                            <div class="call-to-action">
                              <a
                                v-if="item.cta[0]"
                                v-bind:target="item.cta[0].cta.target"
                                v-bind:href="item.cta[0].cta.href"
                                class="btn cta-pill filled-red icon right-arrow"
                                >{{ item.cta[0].cta.text }}</a
                              >
                              <a
                                v-if="item.cta[1]"
                                v-bind:target="item.cta[1].cta.target"
                                v-bind:href="item.cta[1].cta.href"
                                class="
                                  btn
                                  cta-pill
                                  hallow-white
                                  icon
                                  right-arrow
                                "
                                >{{ item.cta[1].cta.text }}</a
                              >
                            </div>
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>

                  <a
                    href="#"
                    v-on:click.prevent="overflow = !overflow"
                    v-if="overflow"
                    class="
                      d-inline-block d-md-none
                      btn
                      cta-pill
                      hallow-red
                      icon
                      move-expand
                    "
                    style="margin: 3rem auto 0 auto"
                    >Load more</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-show="sliderControlsVisible">
          <div class="col">
            <div ref="swiperPagination" class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "component-d6f08142", // card_carousel_2col_icon-line_graphic_text_2cta
  props: ["acf"],
  data() {
    return {
      slider: undefined,
      overflow: this.acf.items.length > 2,
      style: {},
      initialized: false,
    };
  },
  mixins: [helper],
  computed: {
    sliderControlsVisible() {
      return this.shouldUseSlider && this.acf.items.length > 2;
    },
    shouldUseSlider() {
      return !["xs", "sm"].includes(this.$root.mode);
    },
  },
  watch: {
    shouldUseSlider(v) {
      if (this.initialized) {
        if (v) {
          this.swhReload();
        } else {
          this.overflow = this.acf.items.length > 2;
          this.swhDestroy();
        }
      }
    },
    "$root.mode": {
      handler(arg) {
        this.style = {};
        this.style[
          "background-image"
        ] = `url(${this.acf.layout["background-image"]})`;
        this.style["background-color"] = this.acf.layout["background-color"];

        if (arg === "md" || arg === "lg" || arg === "xl") {
          this.style["padding-top"] = this.acf.layout["padding-top"];
          this.style["padding-bottom"] = this.acf.layout["padding-bottom"];
        }
      },

      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.shouldUseSlider) {
        this.swhReload();
      }

      this.initialized = true;
    });
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-d6f08142 {
  padding: 5rem 0 4rem 0;
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
}

.component {
  &.text-color-white {
    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    position: relative;
    @extend %eyebrow-center;

    @media (min-width: 768px) {
      margin-bottom: 0.75rem;
    }
  }

  h3 {
    margin-bottom: 0.325rem;
    color: $cc-resmed-white;
  }

  .item {
    p {
      color: $cc-resmed-white;
      margin: 0 auto 1.5rem auto;
      max-width: 300px;
    }

    .btn {
      margin-left: 0.5rem;
      margin-right: 0.5rem;

      &:last-child {
        margin-top: 0.75rem;
      }

      &:first-child {
        margin-top: 0;
      }
    }
  }

  @media (max-width: 767px) {
    .overflow {
      display: none;
    }
  }

  @media (max-width: 991px) {
    .swiper {
      max-width: none;
      width: 90vw !important;
    }
  }

  .text-color-reverse {
    h3,
    p {
      color: $cc-resmed-black;
    }
  }

  .seek-wrapper {
    position: absolute;
    z-index: 1;

    width: 30%;
    bottom: -42px;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 992px) {
      width: 20%;
    }

    @media (min-width: 1306px) {
      width: 100%;
      bottom: auto;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    a:nth-child(1) {
      float: left;
      transform: translateX(-4rem) scale(1.4);
    }

    a:nth-child(2) {
      float: right;
      transform: translateX(4rem) scale(1.4);
    }
  }

  .-mode-md,
  .-mode-lg,
  .-mode-xl {
    &.swiper-container {
      position: relative;
      width: 100%;
      height: 100%;

      overflow: hidden;
      padding: 1rem 0 2rem 0;
      margin: 0 auto;
      z-index: 1;
    }

    .items {
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    .item {
      display: flex;
      flex-shrink: 0;
      align-items: center;

      padding: 0 0.725rem;
    }
  }

  .item {
    padding: 0 0.625rem;

    > div {
      box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
      // box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.125)
    }

    %zoom {
      &:hover {
        ~ img {
          transform: scale(1.25);
        }
      }
    }

    .embed-responsive-item {
      border-radius: 6px;
      overflow: hidden;
    }

    .embed-responsive-3by4 {
      &:before {
        padding-top: 134%; // round up 133.3333… 1px rendering issue
      }
    }

    figure {
      .gradient {
        width: 100%;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
        opacity: 0.8;

        position: absolute;
        z-index: 2;
      }

      img {
        position: absolute;
        transform: scale(1.0625);
        transition: transform 0.5s ease-out;
      }

      figcaption {
        position: absolute;
        bottom: 0;
        z-index: 3;

        text-align: center;
        margin: 0 auto;
        padding: 0 1rem 2rem 1rem;
        width: 100%;

        left: 50%;
        transform: translateX(-50%);

        @extend %zoom;

        @media (min-width: 992px) {
          padding: 0 1rem 3rem 1rem;
        }
      }
    }
  }
}
</style>